import React from 'react';
import {
  SuturesDetailsContainer,
  TableContainer,
  Table,
  TableHeader,
  TableRow,
  TableData,
  CTAButton,
  TableHeading,
} from './styled';
import { suturesTlacRows, suturesTsorbRows } from './types';
import { useNavigate } from 'react-router-dom';

const SuturesDetails: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
    <SuturesDetailsContainer>
      <TableContainer>
        <TableHeading>Tsorb</TableHeading>
        <Table>
          <thead>
            <TableHeader>
              <th>USP Size</th>
              <th>Metric Size</th>
              <th>Diameter Minimum (mm)</th>
              <th>Diameter Maximum (mm)</th>
              <th>Average K.P.T.S (Kgf)</th>
            </TableHeader>
          </thead>
          <tbody>
            {suturesTsorbRows.map((row, i) => (
              <TableRow key={i} alt={i % 2 !== 0}>
                <TableData>{row.uspSize}</TableData>
                <TableData>{row.metricSize}</TableData>
                <TableData>{row.diameterMin}</TableData>
                <TableData>{row.diameterMax}</TableData>
                <TableData>{row.avgKPTS}</TableData>
              </TableRow>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <CTAButton onClick={() => navigate('/?scroll=contact')}>Get In touch</CTAButton>
    </SuturesDetailsContainer>
    <SuturesDetailsContainer style={{ marginTop: '144px' }}>
      <TableContainer>
        <TableHeading>Tlac</TableHeading>
        <Table>
          <thead>
            <TableHeader>
              <th>USP Size</th>
              <th>Metric Size</th>
              <th>Diameter Minimum (mm)</th>
              <th>Diameter Maximum (mm)</th>
              <th>Average maximum oversize (mm)</th>
              <th>Average K.P.T.S (Kgf)</th>
            </TableHeader>
          </thead>
          <tbody>
            {suturesTlacRows.map((row, i) => (
              <TableRow key={i} alt={i % 2 !== 0}>
                <TableData>{row.uspSize}</TableData>
                <TableData>{row.metricSize}</TableData>
                <TableData>{row.diameterMin}</TableData>
                <TableData>{row.diameterMax}</TableData>
                <TableData>{row.avgMaxOversize}</TableData>
                <TableData>{row.avgKPTS}</TableData>
              </TableRow>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <CTAButton onClick={() => navigate('/?scroll=contact')}>Get In touch</CTAButton>
    </SuturesDetailsContainer>
    </>
  );
};

export default SuturesDetails;
